const setValue = (options, getOptionValue, onChange) => ({
  target: {
    value
  }
}) => {
  // always return an empty string explicitly for "empty" options since we don't know the expected shape of option and therefore how getOptionValue works
  if (value === undefined) {
    return onChange('');
  }

  const foundOption = options.find(option => getOptionValue(option) === value);
  onChange(getOptionValue(foundOption));
};

export { setValue };